<template>
    <div class="modal fade detail-boat" :id="idModalBoatRec" tabindex="-1" role="dialog" aria-labelledby="myLargeModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">EMBARCACION {{ nameShip }} </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" :disabled="btnSend">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">

                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="nombre_embarcacion" class="badge badge-primary">Nombre de la Embarcacion</label>                    
                            <input type="text" class="form-control" v-model="boat.name_boat" id="enrollment_boat" placeholder="Nombre Embarcacion" autocomplete="off">
                        </div>
                        
                        <div class="form-group col-12 col-md-6">
                            <label for="bandera_embarcacion" class="badge badge-primary">Bandera</label>
                            <input type="text" class="form-control" v-model="boat.flag" name="flag" disabled placeholder="BOLIVIA" autocomplete="off">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="material_head" class="badge badge-primary">Material del casco</label>
                            <select class="form-control" name="material_head" v-model="boat.material_head">
                                <option v-for="head in materialHeads" :value="head.id" :key="head.id">{{ head.detail }}</option>
                            </select>
                        </div>
                        
                        <div class="form-group col-12 col-md-6">
                            <label for="type_navigate" class="badge badge-primary">Tipo Navegacion</label>
                            <select class="form-control" name="type_navigate" v-model="boat.type_navigate">
                                <option v-for="navigate in typeNavigates" :value="navigate.id" :key="navigate.id">{{ navigate.detail }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="type_ship" class="badge badge-primary">Tipo de nave</label>
                            <select class="form-control" name="type_ship" v-model="boat.type_boat">
                                <option v-for="ship in typeShips" :value="ship.id" :key="ship.id">{{ ship.detail }}</option>
                            </select>
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="type_ship" class="badge badge-primary">Tipo de Propulsion</label>
                            <select class="form-control" name="type_ship" v-model="boat.propulsion">
                                <option v-for="propulsion in typePropulsions" :value="propulsion.id" :key="propulsion.id">{{ propulsion.detail }}</option>
                            </select>
                        </div>                                              
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-4" v-if="typeForm==='rectifi'">
                            <label for="fecha_ultimo" class="badge badge-primary">ULTIMA PRESENTACION u RENOVACION</label>
                            <input type="date" name="fecha_ultimo" class="form-control" placeholder="FECHA ULTIMA" v-model="boat.fecha_ultimo" autocomplete="off">
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="trb" class="badge badge-primary">TRB</label>
                            <input type="number" name="trb" class="form-control" placeholder="TRB" v-model="boat.trb" autocomplete="off">
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="trn" class="badge badge-primary">TRN</label>
                            <input type="number" name="trn" class="form-control" placeholder="TRN" v-model="boat.trn" autocomplete="off">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-3">
                            <label for="eslora" class="badge badge-primary">Eslora</label>
                            <input type="number" class="form-control" v-model="boat.eslora" name="eslora" placeholder="Eslora" autocomplete="off">
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="manga" class="badge badge-primary">Manga</label>
                            <input type="number" class="form-control" v-model="boat.manga" name="manga" placeholder="Manga" autocomplete="off">
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="puntal" class="badge badge-primary">Puntal</label>
                            <input type="number" class="form-control" v-model="boat.puntal" name="puntal" placeholder="Puntal" autocomplete="off">
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="eslora" class="badge badge-primary">Calado</label>
                            <input type="number" class="form-control" v-model="boat.calado" name="calado" placeholder="Calado" autocomplete="off">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-3">
                            <label for="year_construction" class="badge badge-primary">Año de construccion</label>
                            <input type="number" class="form-control" v-model="boat.year_construction" name="flag" placeholder="Año" autocomplete="off">
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="site_contruction" class="badge badge-primary">Lugar construccion</label>
                            <input type="text" class="form-control" v-model="boat.site_contruction" name="call_sign" placeholder="Lugar de construccion" autocomplete="off">
                        </div>

                        <div class="form-group col-12 col-md-3">
                            <label for="cost_construction" class="badge badge-primary">Costo de construccion</label>
                            <input type="number" class="form-control" v-model="boat.cost_construction" name="cost_construction" placeholder="Costo" autocomplete="off">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="type_ship" class="badge badge-primary">Destino Actividad</label>
                            <select class="form-control" name="type_ship" v-model="boat.parameters_traffic">
                                <option v-for="activity in typesActivityShip" :value="activity.id" :key="activity.id">{{ activity.detail }}</option>
                            </select>
                        </div>
                        
                        <div class="form-group col-12 col-md-6">
                            <label for="type_service" class="badge badge-primary">Tipo de Servicio</label>
                            <select class="form-control" name="type_service" v-model="boat.destiny_boat">
                                <option v-for="service in typeServices" :value="service.id" :key="service.id">{{ service.detail }}</option>
                            </select>
                        </div>
                        
                    </div>

                </div> 
                    
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-success" :disabled="btnSend" @click="mValidateDts" v-if="isEditable"><font-awesome-icon icon="save" size="lg" /></button>
                    <button type="button" class="btn btn-outline-danger" name="closeMod" id="closeMod" data-dismiss="modal" :disabled="btnSend"><font-awesome-icon icon="times-circle" size="lg" /></button>                        
                </div>
                <div style="display:none">{{ tyService }}</div>
            </div>
        </div>            
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
const qs = require('qs');

export default {
    name:'modal-boat',
    props:{
        nameShip:String,
        idModalBoatRec:String,
        boat:Object,
        materialHeads:Array,
        typeNavigates:Array,
        typeShips:Array,
        typePropulsions:Array,
        typesActivityShip:Array,
        isEditable:{
            type:Boolean,
            default:true
        },
        typeForm:{
            type:String,
            default:'rectifi'
        }
    },
    data(){
        return {
            btnSend:false,
            typeServices:[]
        }
    },
    methods:{
        mValidateDts(){                
                if( !this.boat.name_boat)
                    { toastr.error("Indique el Nombre de la Nave"); return false; }
                if( !this.boat.material_head)
                    { toastr.error("seleccione el material"); return false; }
                if( !this.boat.type_navigate)
                    { toastr.error("seleccione el tipo de navegacion"); return false; }
                if( !this.boat.type_boat)
                    { toastr.error("seleccione el tipo de bote"); return false; }
                if( !this.boat.propulsion)
                    { toastr.error("Seleccione el tipo de propulsion"); return false; }
                if( !this.boat.trb)
                    { toastr.error("Indique el TRB"); return false; }
                if( !this.boat.trn)
                    { toastr.error("Indique el TRN"); return false; }
                if( !this.boat.eslora)
                    { toastr.error("Indique la eslora"); return false; }
                if( !this.boat.manga)
                    { toastr.error("Indique la dimension de la manga"); return false; }
                if( !this.boat.puntal)
                    { toastr.error("Indique la dimension del puntal"); return false; }
                if( !this.boat.calado)
                    { toastr.error("Indique la dimension del calado"); return false; }
                if( !this.boat.year_construction)
                    { toastr.error("Indique el año de construccion"); return false; }
                if( !this.boat.site_contruction)
                    { toastr.error("Indique el Sitio de Construccion"); return false; }
                if( !this.boat.cost_construction)
                    { toastr.error("Indique el costo de construccion"); return false; }
                if( !this.boat.parameters_traffic)
                    { toastr.error("Seleccione el tipo de Servicio"); return false; }
                if( !this.boat.destiny_boat)
                    { toastr.error("Seleccione el detino de la actividad"); return false; }
                
                if(this.typeForm==='rectifi'){
                    if( !this.boat.fecha_ultimo)
                        { toastr.error("Seleccione la ultima fecha de presentacion"); return false; }
                }

                if( parseFloat(this.boat.trb) <= parseFloat(this.boat.trn))
                    { toastr.error('El TRN debe ser menor al TRB'); return false; }           
                console.log(this.boat.parameters_traffic)
                this.mSendDts();
        },
        mSendDts(){
            let url='';
            if(this.typeForm==='rectifi'){
                // aqui la url es para rectificacion tambien la fecha de ultima revision no considerar
                url='updateBoat';
            }else{
                // debemos actualizar la tabla hacer un update y colocar en modo vencido la matricula y no considerar la fecha de actualizacion sino directamente colocar a estado vencido y colocar estado de verificacion a revisado
                url='updateBoatRenew';
            }
            this.btnSend=true;
            toastr.info('Actualizando los datos');
            let as={
                nb:JSON.stringify(this.boat)
            }
            axios.post(`${url}?api_token=${Vue.auth.getToken()}`, qs.stringify(as))
            // axios.post(`updateBoat`, qs.stringify(as))
                .then((res)=>{
                    setTimeout(()=>{
                        toastr.success(res.data[0].respuesta);
                        this.btnSend=false;
                        // this.searchBoat();
                        this.closeModal();
                    }, 2000)
                    
                })
                .catch(err=>{
                    console.error(err)
                    this.btnSend=false;
                })
        },
        closeModal() {
            console.log('presionando el boton de close');
             $(`#${this.idModalBoatRec}`).modal('hide')
        }
    },
    computed:{
        tyService(){
            this.btnSend=true; 
            axios.get(`submenus/${this.boat.parameters_traffic}?api_token=${Vue.auth.getToken()}`)
            // axios.get(`submenus/${this.boat.parameters_traffic}`)
            .then
            (res => {                
                this.typeServices=res.data;
                this.btnSend=false;
            })
            .catch(err => {
                console.error(err)
            })
            
        }
    }
}
</script>

<style>
.detail-boat{
    overflow-y: scroll !important;
}
</style>



// WEBPACK FOOTER //
// src/components/rectification/ModalBoat.vue